<script>
    import { fly } from 'svelte/transition';
    import { indexOf } from 'lodash';
    import { state } from '../store/stores.js';
    import Modal from './Modal.svelte';
    import FinalScene from './FinalScene.svelte';
    import MatchingScene from './MatchingScene.svelte';
    import Navigation from './Navigation.svelte';
    import ZoomedImages from './ZoomedImages.svelte';
    import IntroScene from './IntroScene.svelte';
    import Dialog from './Dialog.svelte';
    import GrandmotherHistory from './GrandmotherHistory.svelte';
    import PhotoAlbumInfo from './PhotoAlbumInfo.svelte';
    import Instructions from './Instructions.svelte';

    import {
        getFrontImages,
        getBackImages,
        isFrontImageSelected as isFrontImageSelectedSelector,
        isBackImageSelected as isBackImageSelectedSelector,
        getMatchedImageIds,
        getMatchedSurvivors,
        getMatchedVictims,
        showLargeImages,
        areAllImagesMatched,
        isInitState,
        getSelectedFrontImageId,
        getSelectedBackImageId,
        getFamilyMember,
        areAllActCardsMatched,
        isFinalSceneActive as isFinalSceneActiveSelector
    } from '../store/selectors';
    import {
        setActualCards,
        addCardToSelectedFrontImage,
        addCardToSelectedBackImage,
        resetSelectedImages,
        resetState,
        setSelectedFrontAndBackImage,
        startFinalScene
    } from '../store/actions';

    $: frontImages = getFrontImages($state);
    $: backImages = getBackImages($state);

    $: matchedImageIds = getMatchedImageIds($state);
    $: survivors = getMatchedSurvivors($state);
    $: victims = getMatchedVictims($state);
    $: selectedFrontImageId = getSelectedFrontImageId($state);
    $: selectedBackImageId = getSelectedBackImageId($state);

    $: isModalOpen = showLargeImages($state);
    $: isFinalSceneActive = isFinalSceneActiveSelector($state);
    $: showIntro = isInitState($state);
    $: zoomedImagesComponent = {
		component: ZoomedImages,
		props: {
            image1: getFamilyMember($state, getSelectedFrontImageId($state)),
            image2: getFamilyMember($state, getSelectedBackImageId($state))
        }
    };

    const isFrontImageSelected = imageId => isFrontImageSelectedSelector($state, imageId);
    const isImageHidden = imageId => indexOf(matchedImageIds, imageId) > -1;
    const onFrontImageClick = imageId => addCardToSelectedFrontImage(state, imageId);

    const isBackImageSelected = imageId => isBackImageSelectedSelector($state, imageId);
    const onBackImageClick = imageId => addCardToSelectedBackImage(state, imageId);

    const onModalClose = () => {
        resetSelectedImages(state);
        
        if (areAllActCardsMatched($state)) {
            setActualCards(state);
        }

        if(areAllImagesMatched($state)) {
            startFinalScene(state);
        }
    }

    const bookSound = new Howl({
        src: ['sounds/book_sound_effect.mp3']
    });

    const onBookClick = () => {
        bookSound.play();
        setActualCards(state);
    };

    $: isDialogOpen = false;
    $: dialogContent = GrandmotherHistory;

    const showGrandmotherHistory = () => {
        dialogContent = GrandmotherHistory;
        isDialogOpen = !isDialogOpen;
    }

    const showInstructions = () => {
        dialogContent = Instructions;
        isDialogOpen = !isDialogOpen;
    }

    const showPhotoAlbumInfo = () => {
        dialogContent = PhotoAlbumInfo;
        isDialogOpen = !isDialogOpen;
    }
    const closeDialog = () => {
        isDialogOpen = !isDialogOpen;
    }
    const onRestart = () => resetState(state);

    const onFinalSceneImageClick = imageId => {
        setSelectedFrontAndBackImage(state, imageId);
    };
</script>

<div class="card-game-container" in:fly>
    {#if !isFinalSceneActive}
        {#if showIntro}
            <IntroScene {onBookClick} {showGrandmotherHistory} {showPhotoAlbumInfo} {showInstructions} />
        {/if}

        {#if !showIntro}
            <MatchingScene
                {frontImages}
                {backImages}
                {isFrontImageSelected}
                {isBackImageSelected}
                {onFrontImageClick}
                {onBackImageClick}
                {isImageHidden}
                {showInstructions}
                {selectedFrontImageId}
                {selectedBackImageId}
            />
            <Navigation
                {isFinalSceneActive}
                {survivors}
                {victims}
                {onBookClick}
                {showPhotoAlbumInfo}
            />
        {/if}
    {/if}  
    
    {#if isFinalSceneActive}
        <FinalScene images={victims} {onRestart} {onFinalSceneImageClick}/>
    {/if}
    
    <Modal
        isOpen={isModalOpen}
        onClose={onModalClose}
        component={zoomedImagesComponent.component}
        props={zoomedImagesComponent.props}
    />
    <Dialog isOpen={isDialogOpen} onClose={closeDialog} component={dialogContent} />
</div>

<style>
    .card-game-container {
        height: 100%;
		background: url('../images/extra_elements/background_desk.png') no-repeat center center fixed; 
		-webkit-background-size: cover;
		-moz-background-size: cover;
		-o-background-size: cover;
		background-size: cover;
	}
</style>